<template>
  <BaseSelectMultiple
    v-model="modelValue"
    :options="options"
  >
    <template #button>
      <button
        type="button"
        class="flex w-full items-center justify-between rounded-full border border-background-fg/8 p-1 shadow-sm"
        :class="[
          modelValue.length
            ? 'bg-primary text-white'
            : 'bg-background',
          'disabled:opacity-70',
        ]"
      >
        <span
          :class="[
            modelValue.length
              ? ''
              : 'text-background-fg/70',
            'mx-2 line-clamp-1 text-xs font-medium',
          ]"
        >
          <template v-if="selectedOptionsLabel">
            {{ selectedOptionsLabel }}
          </template>
          <template v-else>
            {{ props.label }}
          </template>
        </span>
        <IconChevronDown
          class="rounded-full bg-background-fg/10"
        />
      </button>
    </template>
  </BaseSelectMultiple>
</template>

<script
  setup
  lang="ts"
  generic="
    TValue extends string | number | undefined | null
  "
>
import type { Option } from "@/composables/options/options"

const props = defineProps<{
  options: ReadonlyArray<Option<TValue>>
  label: string
}>()

const modelValue = defineModel<Array<TValue>>({
  required: true,
})

const selectedOptionsLabel = computed(() =>
  modelValue.value
    .map(
      (selectedValue) =>
        props.options.find(
          ({ value }) => value === selectedValue
        )?.label
    )
    .join(", ")
)
</script>
